import { ProviderStorable } from '../../core/provider-storable.js';

/**
 * @internal
 */
class MiddlewareProvider extends ProviderStorable {
}

export { MiddlewareProvider };
//# sourceMappingURL=middleware-provider.js.map
